import * as angular from 'angular';
import MaintenanceFlowModelsBridge from './MaintenanceFlowModelsBridge';

angular
  .module('flowingly.runner.maintenance')
  .component('maintenanceFlowModels', MaintenanceFlowModelsBridge);
